'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useWalletConnectMetadata } from '../../../hooks/useWalletConnectMetadata';
import { useUserAccount } from '../../../providers/UserAccountProvider';
import { SAFE_CONNECTOR_ID } from '../../../utils';

/**
 * Resolve wallet-level metadata for the active account so that action-flow
 * tracking events and structured logs can be segmented by wallet type.
 *
 * Safe detection is synchronous:
 *   - `connector.id === 'safe'` catches the Safe App connector.
 *   - WalletConnect peer metadata catches Safe accounts connected via WC.
 *
 * `walletConnectPeerName` is the peer app name reported over WalletConnect
 * (e.g. "Rabby", "Rainbow", "Safe{Wallet}"), so telemetry can distinguish
 * cloaked wallet identities that all report as the `walletConnect` connector.
 */
export function useActionFlowWalletMetadata() {
  const $ = _c(5);
  const {
    connector
  } = useUserAccount();
  const {
    isSafeAccountViaWalletConnect,
    walletConnectPeerName
  } = useWalletConnectMetadata();
  connector?.id;
  connector?.name;
  const t0 = connector?.id;
  const t1 = connector?.name;
  const t2 = connector?.id === SAFE_CONNECTOR_ID || isSafeAccountViaWalletConnect;
  const t3 = walletConnectPeerName || undefined;
  let t4;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = {
      connectorId: t0,
      connectorName: t1,
      isSafeWallet: t2,
      walletConnectPeerName: t3
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}